import { type FieldReadNestedTarget } from '../field-read-module.ts';

export type EntryDetailsReadContent = {
  readonly kind: 'entry-details';
  readonly targets: readonly FieldReadNestedTarget[];
};

export const EMPTY_ENTRY_DETAILS_CONTENT: EntryDetailsReadContent = Object.freeze({
  kind: 'entry-details',
  targets: Object.freeze([])
});
